import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["uf", "municipio"]

  connect() {
    // initialize UF choice
    this.ufChoices = new Choices(this.ufTarget, {
      searchPlaceholderValue: "Buscar UF…",
      shouldSort: false,
      itemSelectText: '',
      noResultsText: '',
      noChoicesText: ''
    })

    // Ensure the <select> has a placeholder option before Choices wraps it.
    // This makes the initial text show reliably.
    if (this.municipioTarget.options.length === 0) {
      const opt = document.createElement("option")
      opt.value = ""
      opt.text = "Selecione a UF primeiro"
      opt.disabled = true
      opt.selected = true
      this.municipioTarget.appendChild(opt)
    }

    // initialize municipio choice
    this.municipioChoices = new Choices(this.municipioTarget, {
      searchPlaceholderValue: "Buscar município…",
      noResultsText: "Nenhum município encontrado",
      shouldSort: false,
      placeholder: true,
      placeholderValue: "Selecione a UF primeiro",
      itemSelectText: '',
      noResultsText: '',
      noChoicesText: ''
    })

    // start disabled (won't allow selection until a UF selected)
    this.municipioChoices.disable()
  }

  async onUfChange(event) {
    const sigla = event.target.value

    // Reset to initial state if blank
    if (!sigla) {
      this._setMunicipioPlaceholder("Selecione a UF primeiro")
      this.municipioChoices.disable()
      return
    }

    // Show loading text + spinner
    this.municipioChoices._placeholderValue = "Selecione o município"
    this.element.classList.add("is-loading") // used by CSS to show spinner
    this.municipioChoices.disable()

    try {
      const res = await fetch(`/ufs/${encodeURIComponent(sigla)}/municipios.json`, {
        headers: { "Accept": "application/json" }
      })

      if (!res.ok) throw new Error(`HTTP ${res.status}`)

      const data = await res.json()

      // Map API results -> choices
      const choices = data.map(m => ({
        value: m.id,
        label: m.nome
      }))

      // Replace choices in one call (fast)
      this.municipioChoices.clearStore()
      if (choices.length === 0) {
        this.municipioChoices._placeholderValue = "Nenhum município encontrado"
        this.municipioChoices.setChoices(
          [{ value: "", label: "Nenhum município encontrado", disabled: true }],
          "value",
          "label"
        )
        this.municipioChoices.disable()
      } else {
        this.municipioChoices._placeholderValue = "Selecione o município"
        this.municipioChoices.setChoices(choices, "value", "label")
        this.municipioTarget.value = ""
        this.municipioChoices.enable()
        // ensure nothing is selected automatically:
        try { this.municipioChoices.removeActiveItems() } catch(e) {}
      }
    } catch (err) {
      console.error("Failed to load municipios:", err)
      this.municipioChoices.clearStore()
     this.municipioChoices._placeholderValue = "Erro ao carregar municípios"
      this.municipioChoices.disable()
    } finally {
      this.element.classList.remove("is-loading")
    }
  }
}
